import { create } from 'zustand';
import type { User } from '@nasabtree/shared-types';
import { getStoredToken, storeToken, clearToken } from '../lib/auth';

interface AuthState {
  user: User | null;
  accessToken: string | null;
  setAuth: (user: User, token: string) => void;
  clearAuth: () => void;
}

export const useAuthStore = create<AuthState>()((set) => ({
  user: null,
  accessToken: getStoredToken(),
  setAuth: (user, token) => {
    storeToken(token);
    set({ user, accessToken: token });
  },
  clearAuth: () => {
    clearToken();
    set({ user: null, accessToken: null });
  },
}));
